PJQ.views.changeRequests.ChangeRequestsList = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'change-requests-list'),
        subTemplates: {
            totals: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'change-requests-totals')
        },
        changeRequestId: null
    },
    events: {
        'click .btn-settings': 'editSettings',
        'click .btn-add-change-request': 'addChangeRequest',
        'click .btn-delete-change-request': 'deleteChangeRequestClicked',
        'click .btn-export': 'exportChangeRequestList'
    },
    beforeFirstRender: async function () {
        this.isFetched = false;
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        if (this.collection == null) {
            this.collection = new PJQ.collections.changeRequests.ChangeRequests(null, {
                projectId: this.options.project.get('projectId'),
                groupId: this.options.groupId ? this.options.groupId : null,
                costTypeId: this.options.costTypeId ? this.options.costTypeId : null
            });
        }

        if (!this.collection.isFetched) {
            await this.collection.fetch();
        }

        this.customFields = await this.options.project.fetchChangeRequestCustomFields();
        this.userSettings = await PJQ.app.session.fetchChangeRequestUserSettings();
        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();
        this.settings = await this.options.project.fetchChangeRequestSettings();

        if (this.settings.get('enableStandardListView')) {
            this.subJobs = await this.options.project.fetchSubJobs();
            this.costCodes = await this.options.project.fetchCostCodes();
            this.costTypes = await this.options.project.fetchCostTypes();
        }

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.options.isAdmin = PJQ.app.session.project.hasPermission('changeRequests.isAdmin');
        this.options.canAdd = PJQ.app.session.project.hasPermission('changeRequests.canAdd');
    },
    renderData: function () {
        return {
            collection: this.collection,
            isFetched: this.isFetched,
            isAdmin: this.options.isAdmin,
            hideHeader: this.options.hideHeader,
            canAdd: this.options.canAdd
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.renderView();

        PJQ.app.session.project.off('changeRequestChanged');
        PJQ.app.session.project.on('changeRequestChanged', function (changeRequest) {
            this.collection.add(changeRequest);
            this.render();
        }, this);

        if (this.options.rfqId > 0) {
            let rfq = new PJQ.models.rfq.RFQ({
                id: this.options.rfqId
            });

            rfq.fetch({
                success: _.bind(function () {
                    this.viewRFQ(rfq);
                }, this)
            });
        } else if (this.options.changeRequestId > 0) {
            let initChangeRequest = this.collection.get(this.options.changeRequestId);
            if (initChangeRequest != null) {
                this.viewChangeRequest(initChangeRequest);
                this.options.changeRequestId = null;
            }
        }
        this.renderStats();
    },
    renderStats: function () {
        let totals,
            $totals = this.$('.totals-outer');
        if (this.collection == null || !this.collection.isFetched) {
            $totals.empty();
            return;
        }

        totals = this.collection.getTotalAmountsByStatus();
        this.renderSubTemplate(false, this.options.subTemplates.totals, $totals, {
            pending: totals[PJQ.constants.changeRequests.changeRequestStatusBuckets.PENDING.name],
            projected: totals[PJQ.constants.changeRequests.changeRequestStatusBuckets.PROJECTED.name],
            approved: totals[PJQ.constants.changeRequests.changeRequestStatusBuckets.APPROVED.name]
        });
    },
    renderView: function () {
        if (this.dataTable) {
            this.dataTable.remove();
            this.dataTable = null;
        }

        this.dataTable = this.getDataTableInstance();
    },
    getDataTableInstance: function () {
        return new PJQ.views.changeRequests.ChangeRequestDataTable({
            el: this.$('.change-requests-data'),
            rowId: "cid",
            data: this.collection.models,
            orderCookie: PJQ.constants.cookies.CHANGE_REQUEST_ORDER_COOKIE,
            isAdmin: this.options.isAdmin,
            costCodes: this.costCodes,
            costTypes: this.costTypes,
            subJobs: this.subJobs,
            companySettings: this.settings,
            headerData: _.bind(function () {
                return {
                    project: this.options.project,
                    isAdmin: this.options.isAdmin,
                    canAdd: this.options.canAdd,
                    isStandardListView: this.settings.get('enableStandardListView'),
                };
            }, this),
            userSettings: this.userSettings,
            settings: this.userSettings.getSettings(PJQ.constants.changeRequests.view.CHANGE_REQUESTS),
            order: [[1, 'asc']],
            colReorder: {
                fixedColumnsLeft: 1,
                fixedColumnsRight: 1,
                realtime: false
            },
            columnOrderChanged: () => {
                this.userSettings.save();
            },
            onViewChangeRequest: (changeRequest) => {
                this.viewChangeRequest(changeRequest);
            },
            onRowDoubleClick: (row) => {
                if (row.data()) {
                    this.viewChangeRequest(row.data());
                }
            },
            onCreateFromLineItems: async (lineItems) => {
                await this.collection.fetch();
                this.dataTable.resetData(this.collection.models);
            },
            contextMenuOptions: {
                actions: [
                    {
                        name: 'View',
                        onClick: (row) => {
                            this.viewChangeRequest(row.data());
                        }
                    }
                ]
            }
        });
    },
    exportChangeRequestList: function (e) {
        if (this.options.project == null) {
            return;
        }

        let type = 'excel',
            orderCookie = PJQ.helpers.cookieHelpers.getCookie(PJQ.constants.cookies.CHANGE_REQUEST_ORDER_COOKIE),
            order = orderCookie != null ? JSON.parse(orderCookie) : null,
            columns = this.userSettings.getSettings(PJQ.constants.changeRequests.view.CHANGE_REQUESTS).columns;

        // There is an extra column in the datatable for icons. Subtract 1 to get the correct order.
        if(order != null && Array.isArray(order[0]) && typeof order[0][0] === 'number'){
            order[0][0] = order[0][0] - 1;
        }

        // Some of the columns have different names than the report center definitions. This will change them to the correct names.
        let changeTerms = {
            "createdOn": "created",
            "client.companyName": "client",
            "primeContract": "contract",
            "amount": "cost"
        };
        columns = _.map(columns, column => changeTerms[column] || column);

        let report = new PJQ.models.reports.NewReport({
            type: PJQ.constants.reports.reportTypes.CHANGE_REQUEST.type,
            projectId: this.options.project ? this.options.project.id : null,
            options: {
                columns: columns,
                columnOrder: order
            }
        });
        report.export({format: type}).then(() => {

        });
    },
    viewChangeRequestClicked: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        this.viewChangeRequest(row.data());
    },
    viewRFQ(rfq) {
        new PJQ.views.rfq.RFQEditModal({
            model: rfq,
            project: this.options.project
        });
    },
    viewChangeRequest: function (changeRequest, primeContract) {
        let isNew = primeContract != null;
        new PJQ.views.changeRequests.ChangeRequestEditModal({
            model: changeRequest,
            primeContract: primeContract,
            onSave: _.bind(function (changeRequest) {
                if (isNew) {
                    this.collection.add(changeRequest);
                }
                this.renderView();
            }, this),
            onDelete: _.bind(function (changeRequest) {
                this.collection.remove(changeRequest);
                this.renderView();
            }, this)
        });
    },
    addChangeRequest: function () {
        new PJQ.views.primeContracts.SelectPrimeContractsModal({
            isSingleChoice: true,
            project: this.options.project,
            headerSubText: 'Select the Contract you would like to create a Change Request for.',
            filterStatuses: PJQ.constants.primeContracts.primeContractStatus.APPROVED,
            onSave: _.bind(function (contract) {
                this.viewChangeRequest(null, contract);
            }, this)
        });
    },
    deleteChangeRequestClicked: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        this.deleteChangeRequest(row);
    },
    deleteChangeRequest: function (row) {
        if (row != null) {
            let changeRequest = row.data();
            if (changeRequest != null) {
                new PJQ.views.modals.DeleteCancel({
                    header: "Delete Change Request",
                    body: "Are you sure you want to delete this Change Request?",
                    onDelete: _.bind(function () {
                        changeRequest.destroy({
                            success: _.bind(function () {
                                this.dataTable.removeRow(row);
                                if (typeof this.options.onDelete === 'function') {
                                    this.options.onDelete(changeRequest);
                                }
                            }, this)
                        });
                    }, this)
                });
            }
        }
    },
    editSettings: function () {
        new PJQ.views.changeRequests.ChangeRequestSettingsModal({
            changeRequestsView: this,
            settings: this.settings,
            onSave: _.bind(function () {
                this.renderView();
                PJQ.notifications.notify.successNotify({
                    message: 'Settings updated successfully'
                });
            }, this)
        });
    }
});

PJQ.views.changeRequests.SelectChangeRequestsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-select-change-requests'),
        width: '50%',
        maxWidth: 700,
        onSave: _.noop
    },
    events: {
        "change .select-change-request": "selectChangeRequest",
        "click .btn-save": "save",
        "click .btn-cancel": "cancel"
    },
    beforeModalCreated: function () {
        this.options.isAdmin = PJQ.app.session.project.hasPermission('changeRequests.isAdmin');
        this.selectedChangeRequests = [];

        if (this.collection == null) {
            this.collection = new PJQ.collections.changeRequests.ChangeRequests(null, {
                projectId: this.options.project.get('projectId')
            });
        }

        if (this.collection.isFetched) {
            this.render();
        } else {
            this.collection.fetch({
                success: _.bind(function () {
                    this.changeRequests = this.collection.models;

                    if (this.options.primeContractId) {
                        this.changeRequests = _.filter(this.changeRequests, function (model) {
                            return model.get('primeContractId') === this.options.primeContractId
                        }, this);
                    }

                    if (this.options.filterStatuses) {
                        this.changeRequests = _.filter(this.changeRequests, function (model) {
                            let statusId = model.get('statusId');

                            if (_.isArray(this.options.filterStatuses)) {
                                return _.includes(this.options.filterStatuses, statusId);
                            } else if (_.isNumber(this.options.filterStatuses)) {
                                return this.options.filterStatuses === statusId;
                            }

                            return false;

                        }, this);
                    }
                    this.render();
                }, this)
            });
        }

    },
    renderData: function () {
        return {
            headerSubText: this.options.headerSubText,
            isSingleChoice: this.options.isSingleChoice
        }
    },
    afterRender: function () {
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.change-requests-table'),
            data: this.changeRequests,
            isHideSearch: true,
            order: [],
            columns: [{
                "data": "attributes.isSelected",
                "title": "",
                "orderable": false,
                "searchable": false,
                "render": _.bind(function (data) {
                    return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox" ' + (data ? 'checked' : '') + ' class="select-change-request"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                }, this)
            },
                {
                    "data": "attributes.number",
                    "title": "Number",
                    "orderable": true
                },
                {
                    "data": "attributes.client.companyName",
                    "title": "Client",
                    "orderable": true
                },
                {
                    "data": "attributes.description",
                    "title": "Description",
                    "orderable": false
                },
                {
                    "data": "attributes.amount",
                    "title": "Amount",
                    "orderable": false,
                    "className": "text-align-right",
                    "render": _.bind(function (data, type, row) {
                        return PJQ.helpers.formatHelpers.formatCurrency(data);
                    }, this)
                }],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
        });
    },
    selectChangeRequest: function (e) {
        let target = $(e.currentTarget),
            changeRequest = this.dataTable.getRow(target.closest('tr')).data();

        if (this.options.isSingleChoice) {
            this.$('.select-change-request').not(target).text('Select').prop('checked', false);
            if (changeRequest.get('isSelected')) {
                changeRequest.set('isSelected', false);
                this.selectedChangeRequest = null;
            } else {
                changeRequest.set('isSelected', true);
                this.selectedChangeRequest = changeRequest;
                this.collection.get(changeRequest.id);
                _.each(this.collection.models, _.bind(function (dtChangeRequest) {
                    if (changeRequest.id !== dtChangeRequest.id)
                        dtChangeRequest.set('isSelected', false);
                }, this));
            }
            this.$('.btn-save').attr('disabled', this.selectedChangeRequest == null);

            if (typeof this.options.onChangeRequestSelected === 'function') {
                this.options.onChangeRequestSelected(this.selectedChangeRequest);
            }
        } else {
            if (changeRequest.get('isSelected')) {
                target.text('Select').addClass('btn-primary').removeClass('btn-secondary');
                changeRequest.set('isSelected', false);
                this.selectedChangeRequests = _.reject(this.selectedChangeRequests, function (selChangeRequest) {
                    return selChangeRequest.id === changeRequest.id;
                });
            } else {
                target.text('Deselect').addClass('btn-secondary').removeClass('btn-primary');
                changeRequest.set('isSelected', true);
                this.selectedChangeRequests.push(changeRequest);
            }
            this.$('.btn-save').attr('disabled', this.selectedChangeRequests == null);

            if (typeof this.options.onChangeRequestSelected === 'function') {
                this.options.onChangeRequestSelected(this.selectedChangeRequests);
            }
        }
    },
    cancel: function () {
        if (this.options.onCancel) {
            this.options.onCancel();
        }
        this.removeModal();
    },
    save: function () {
        if (this.options.onSave) {
            this.options.onSave(this.selectedChangeRequest ? this.selectedChangeRequest : this.selectedChangeRequests);
            this.removeModal();
        }
    }
});